import React from 'react';
import './Styles/Testimonial.scss';
import Testimonial1 from '../Customer/Testimonial';

const Testimonial=()=>{
    return(
        <div className="wireframe-testimonial">
           <div className="content">
               <h1>Everybody loves working with us</h1>
               <p>Here's what our customers have to say about us.</p>

           </div>
           <Testimonial1 />
        </div>
    )
};
export default Testimonial ;